export default {
    header: {
        title: 'Full-case marketing customization service provider',
        page1: 'Front page',
        page2: 'About WITSTAR',
        page3: 'Success case',
        page4: 'Serve',
        page5: 'Contact us',
        page6: 'Brand going overseas',
    },
    footer: {
        page1: 'Front page',
        page2: 'About WITSTAR',
        page3: 'Success case',
        page4: 'Serve',
        page5: 'Contact us',
        phone: 'Phone',
        email: 'Mail',
        address: 'Kuala Lumpur Address：',
        addressDesc: 'Level 13A-01,02,03 Vertical Business Suite II, Tower B,Bangsar South, 59200 Kuala Lumpur',
        internet: '© 2024. WITSTAR. All rights reserved. Guangdong ICP No. 2023093369-1',
    },
    home: {
        title1: 'Full-case marketing customization service provider',
        desc1: 'Work with great brands',
        title2: 'WITSTAR',
        desc2_1: 'As a well-known brand full-case marketing technology company, WITSTAR is committed to exploring online and offline full life cycle growth for domestic and foreign brands by providing customized solutions across all links, all channels, and all scenarios. Chance. Empower brands in digital marketing, IT custom development, brand overseas, public relations and other businesses to achieve efficient growth.',
        desc2_2: 'Currently, we have companies and offices in Shenzhen and Kuala Lumpur, with more than 100 full-time employees covering professionals in many fields such as brand creation, IT custom development, media operations, video creation, and public relations event services.',
        title3: 'Our service',
        desc3: 'The essence of service is customer satisfaction, and the support for satisfaction is sufficient professionalism',
        title4: 'Featured Cases',
        desc4: 'Like them, grow your business with WITSTAR Services',
        featured: {
            title1: 'Harmony',
            desc1: 'Comprehensive design, development and upgrade of brand product visual image official website, etc.',
            know: 'Learn more',
            title2: 'Dr hair dryer',
            desc2: 'Brand visual concept: caressed by nature, the dawn breeze creates a new elegant style',
            title3: 'Good boy',
            desc3: 'Planned and successfully created a brand image to assist brand marketing strategic layout',
            title4: 'Sony Ericsson brand',
            desc4: 'Friendly, comfortable, and younger lifestyle brings users simple and happy comfort, and makes them happy physically and mentally.',
        },
        advantage: {
            title:  'Our advantage',
            title1: 'Media resources',
            desc1: 'Real-time updates to 15,000+ media resource libraries, including print newspapers, authoritative platforms, portals, etc.',
            title2: 'Talent resources',
            desc2: 'Real-time 126,300+ expert resource library, including major domestic and foreign mainstream media, industry vertical platforms, etc.',
            title3: 'Event resources',
            desc3: 'We have an online and offline execution team with rich experience in 1650+ operations, providing refined process management.',
            title4: 'Digital technology',
            desc4: 'A creative software development and maintenance team of 129+ people provides customized and professional digital system construction.'
        },
        number: {
            title1: 'Media resources',
            title2: 'Talent resources',
            title3: 'Event resources',
            title4: 'Digital technology',
            desc1: 'Home',
            desc2: 'Talent',
            desc3: 'Field',
            desc4: 'People',
        },
        title5: 'Partner media',
        desc5: 'One-stop social media agency operation solution',
        title6: 'Our business partner',
        desc6: 'The essence of service is customer satisfaction, and the support for satisfaction is sufficient professionalism',
    },
    witstar: {
        title1: 'Find the optimal marketing solution for the entire case for customers',
        desc1: 'Who are we',
        title2: 'Make it easier for your brand to go global',
        title3: 'Make your brand',
        title4: 'Value is more evident',
        title5: 'Make your brand communication more comprehensive',
        title6: 'Make your brand',
        title7: 'The sound is more shocking',

    },
    brandOverseas: {
        title1: 'Let the world hear your story',
        desc1: 'Promote brands to go overseas',
        title2: 'Full-link service for brands overseas',
        desc2_1: 'WitStar is a digital marketing service provider for cross-border brands going overseas, focusing on providing customers with one-stop solutions for brands going overseas',
        desc2_2: 'Empowering Chinese cross-border e-commerce enterprise brands to go global through strategic thinking integrating product and sales, project-based indicator management methods, diversified sales channels, rich marketing experience and resources.',
        serveLine: {
            title1: 'Amazon one-stop operation',
            title2: 'Multi-channel expansion',
            title3: 'Independent station operation',
            title4: 'Overseas crowdfunding',
            title5: 'Social Media & Influencer Brand Marketing',
            title6: 'AI intelligent advertising delivery system',
            title7: 'Multi-platform VC distribution such as Amazon',
            title8: 'Advertising optimization and content creative services',
        },
        whatsapp: {
            title1: 'days',
            title2: 'implemented within',
            title3: 'Increase in network exposure',
            title4: 'Through amateur influencers (KOC) and news matrix, we ensure that potential customers are guided to consumption at every key point in the consumer journey and advance the DIGITAL MARKETING marketing strategy.',
            title5: 'Little Red Book Blogger',
            title6: 'WHATSAPP asks for list of influencers',
        },
        caseData: {
            title1: 'Real cases · effect data',
            title2: 'Increase in transaction rate',
            title3: 'Sales time reduced',
            title4: 'WitStar builds a good brand reputation for enterprises through TikTok, Xiaohongshu, Instagram, Facebook and Go0gle, conducts secondary marketing of potential customers, makes positive recommendations to promote purchase decisions, while reducing customers lost due to lack of positive brand information and increasing transaction rates.',
            title5: 'Relevant data comes from WitStar after-sales service team, the number of samples is 273',
            title6: 'Building brand trust is a challenge in business, and salespeople often need to vigorously introduce products and brands. WitStar uses internet celebrity testimonials and authoritative press releases to enhance corporate social certification and help sales quickly win customer confidence.',
        }
    },
    success: {
        title1: 'Global creativity and strong execution',
        desc1: 'Our case',
        title2: 'Every service is an opportunity for word-of-mouth communication',
        title3: 'The essence of service is customer satisfaction. Make every plan carefully, fight every battle, and be responsible to customers.',
    },
    serve: {
        title1: 'Our service',
        desc1_1: 'The essence of service is customer satisfaction',
        desc1_2: 'The support for satisfaction is sufficient professionalism',
        desc2: 'Creative services',
        desc3: 'We create creative content that is in line with brand strategy, helping brands communicate with their target audiences on the same frequency and create emotional connections.',
        title2: 'Brand VI design',
        title3: 'Visual design',
        title4: 'Web Design',
        title5: 'Copywriting',
        title6: 'Creative short video',
        overseas: {
            title1: 'Rapidly increase brand awareness overseas and achieve efficient business growth',
            title2: 'Provide full-case marketing services for brand DTC going overseas',
            title3: 'Integration of the whole overseas case',
            title4: 'Brand overseas research',
            title5: 'Overseas social media marketing',
            title6: 'Overseas KOL marketing',
            title7: 'Overseas offline event planning',
            title8: 'Overseas media and advertising',
            title9: 'Brand going overseas',
        },
        title7: 'Technology development',
        title8: 'APP custom development',
        title9: 'WeChat public account',
        title10: 'Mini program development',
        title11: 'Website upgrade custom development',
        communicate: {
            title1: 'PR communication',
            title2: 'An experienced public relations team makes full use of online and offline communication methods to create good economic and social benefits for the brand.',
            title3: 'Event communication',
            title4: 'Offline press conference',
            title5: 'Media communication',
            title6: 'Media live broadcast',
            title7: 'New media marketing',
        }
    },
    contact: {
        title1: 'Full-case marketing customization service provider',
        desc1: 'Contact us',
        title2: 'Customized marketing promotion helps Chinese brand Yang Fan',
        title3: 'Brand exposure',
        title4: 'Drainage and conversion',
        title4_1: 'Create explosive products',
        title5: 'Tiktok overseas marketing one-stop service',
        title6: 'Influencer marketing',
        title7: 'Agent operation service',
        title8: 'Full case service',
        table: {
            top: 'Covered area',
            title1: 'Asia',
            desc1: 'China, Japan, South Korea, Philippines, Thailand, Singapore, Malaysia, Indonesia, India, Vietnam, Cambodia, Bangladesh, Pakistan, Laos, Brunei...',
            title2: 'Europe',
            desc2: 'United Kingdom, France, Germany, Czech Republic, Russia, Netherlands, Belgium, Norway, Switzerland, Poland, Italy, Spain, Portugal, Ukraine...',
            title3: 'America (South & North)',
            desc3: 'United States, Argentina, Canada, Chile, Colombia, Uruguay, Mexico...',
            title4: 'Africa',
            desc4: 'Egypt, Gambia, Guinea, Congo, Ghana, Zimbabwe, Kenya, Libya, South Africa, Nigeria, Uganda...',
            title5: 'Oceania',
            desc5: 'Australia, New Zealand, Fiji, Solomon Islands...',
            bottom: 'If the target region or country is not on the appeal list, please contact us for more details.'
        }
    },
}